import { useState } from 'react';
import type { GridRowParams } from '@/components/custom/erp';
import { Group, GroupType } from '@/types/schemas';

type FormMode = 'add' | 'edit' | 'view';

export default function useFormState(groupType: GroupType) {
  const [showForm, setShowForm] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [formMode, setFormMode] = useState<FormMode>('add');
  const [selectedObj, setSelectedObj] = useState<Group | null>(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState<string | null>(null);
  const [isCopyMode, setIsCopyMode] = useState(false);

  const handleCloseForm = () => {
    setShowForm(false);
  };

  const handleCloseDelete = () => {
    setShowDelete(false);
  };

  const handleAddClick = () => {
    setFormMode('add');
    setIsCopyMode(false);
    setShowForm(true);
  };

  const handleEditClick = () => {
    setFormMode('edit');
    setShowForm(true);
  };

  const handleViewClick = () => {
    setFormMode('view');
    setShowForm(true);
  };

  const handleDeleteClick = () => {
    setShowDelete(true);
  };

  const handleCopyClick = () => {
    setFormMode('add');
    setIsCopyMode(true);
    setShowForm(true);
  };

  const handleRowClick = (params: GridRowParams<Group>) => {
    setSelectedRowIndex(params.id);
    setSelectedObj(params.row);
  };

  const clearSelection = () => {
    setSelectedRowIndex(null);
    setSelectedObj(null);
  };

  return {
    showForm,
    showDelete,
    formMode,
    selectedObj,
    selectedRowIndex,
    isCopyMode,
    handleCloseForm,
    handleCloseDelete,
    handleAddClick,
    handleEditClick,
    handleViewClick,
    handleDeleteClick,
    handleCopyClick,
    handleRowClick,
    clearSelection
  };
}
